<article class="detail-layout">
    <h1 class="overview-title" translate="Core.ServiceUnavailable.Title"></h1>
    <div class="highlight help-block">
        <div class="highlight__inner">
            <div>
                <h3 translate="Core.ServiceUnavailable.Subtitle"></h3>
                <div [innerHTML]="'Core.ServiceUnavailable.Body' | translate"></div>
            </div>
        </div>
    </div>
</article>
